import { SIDE_PANEL_COLLAPSED_WIDTH, SIDE_PANEL_WIDTHS } from '@hivewatch/dark'

import { FacilityDrawer } from '@/redux/ui/uiSlice.types'

// Collapsed rail width — just enough for the toggle button.
export const COLLAPSED_RAIL_WIDTH = SIDE_PANEL_COLLAPSED_WIDTH

/**
 * Expanded width per drawer.
 *
 * With the rebrand on, every rail follows the Design Library: the Side Panel
 * component set (Foundation, node 1081:50) defines exactly three tiers —
 * Sm=400, Md=480, Lg=560 — and Sm is the tier for a narrow single-column rail.
 * All four drawers now render a rebuilt panel on that component, so the rail
 * keeps one width instead of jumping between drawers.
 *
 * With the flag off each drawer keeps its pre-rebrand width.
 *
 * TODO: have to come up with a better way of calculating the width of the
 * "drawer" component.
 */
const getExpandedWidth = (
  drawer: FacilityDrawer,
  isFacilitiesRebrandEnabled: boolean
) => {
  switch (drawer) {
    case 'devices':
      return isFacilitiesRebrandEnabled ? SIDE_PANEL_WIDTHS.sm : 390
    case 'checkpoints':
      return isFacilitiesRebrandEnabled ? SIDE_PANEL_WIDTHS.sm : 420
    case 'tour-plans':
      return isFacilitiesRebrandEnabled ? SIDE_PANEL_WIDTHS.sm : 390
    case 'floors':
      return isFacilitiesRebrandEnabled ? SIDE_PANEL_WIDTHS.sm : 390
  }
}

interface GetRailWidthIProps {
  drawerOpen: FacilityDrawer
  isPanelExpanded: boolean
  isFacilitiesRebrandEnabled: boolean
}

/**
 * Width of the floor-plan right rail. A pure function rather than a hook — it
 * reads no state and calls no hooks — so both feature-flag branches are unit
 * testable without rendering the floor plan.
 */
export const getRailWidth = ({
  drawerOpen,
  isPanelExpanded,
  isFacilitiesRebrandEnabled,
}: GetRailWidthIProps) =>
  isPanelExpanded
    ? getExpandedWidth(drawerOpen, isFacilitiesRebrandEnabled)
    : COLLAPSED_RAIL_WIDTH
